import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../axios/centralApiAxios";
import EnumRecordTypes from "../../enums/enumRecordTypes";
import { getActivityHeadersUpdated } from "../../utils/parentChildActivities";
import {
  GET_CONTACT_USERNAME_EXIST,
  GET_CONTACT,
  GET_CONTACT_INFORMATION,
  GET_PRIMARY_CONTACT_METHODS,
  GET_CONTACT_METHOD_TYPES,
  GET_CONTACT_TERMS,
  GET_CONTACT_TERMS_SUFFIX,
  CREATE_CONTACT_INFORMATION,
  CREATE_USER_ACCOUNT,
  CHANGE_USER_PASSWORD,
  UPDATE_USER,
  DELETE_USER,
  UPDATE_CONTACT,
} from "../actions";

import {
  getContactUserNameSuccess,
  getContactUserNameError,
  getContactSuccess,
  getNameTitleTermsSuccess,
  getNameSuffixTermsSuccess,
  getContactError,
  getNameTitleTermsError,
  getNameSuffixTermsError,
  getContactInformationSuccess,
  getContactInformationError,
  getPrimaryContactMethodsSuccess,
  getPrimaryContactMethodsError,
  getContactMethodTypesSuccess,
  getContactMethodTypesError,
  createContactInformationSuccess,
  createContactInformationError,
  createUserAccountSuccess,
  createUserAccountError,
  changeUserPasswordSuccess,
  changeUserPasswordError,
  updateUserSuccess,
  updateUserError,
  deleteUserSuccess,
  deleteUserError,
  updateContactSuccess,
  updateContactError
} from "./actions";

export function* watchGetContactUserName() {
  yield takeEvery(GET_CONTACT_USERNAME_EXIST, getContactUserName);
}

export function* watchGetContact() {
  yield takeEvery(GET_CONTACT, getContact);
}

export function* watchUpdateContact() {
  yield takeEvery(UPDATE_CONTACT, updateContact);
}

export function* watchGetContactMethodTypes() {
  yield takeEvery(GET_CONTACT_METHOD_TYPES, getContactMethodTypes);
}

export function* watchGetNameTitleTerms() {
  yield takeEvery(GET_CONTACT_TERMS, getNameTitleTerms);
}

export function* watchGetNameSuffixTerms() {
  yield takeEvery(GET_CONTACT_TERMS_SUFFIX, getNameSuffixTerms);
}

export function* watchGetContactPrimaryAddress() {
  yield takeEvery(GET_PRIMARY_CONTACT_METHODS, getPrimaryContactMethods);
}

export function* watchGetContactInformation() {
  yield takeEvery(GET_CONTACT_INFORMATION, getContactInformation);
}

export function* watchCreateContactInformation() {
  yield takeEvery(CREATE_CONTACT_INFORMATION, createContactInformation);
}

export function* watchCreateUserAccount() {
  yield takeEvery(CREATE_USER_ACCOUNT, createUserAccount);
}

export function* watchChangeUserPassword() {
  yield takeEvery(CHANGE_USER_PASSWORD, changeUserPassword);
}

export function* watchUpdateUser() {
  yield takeEvery(UPDATE_USER, updateUser);
}

export function* watchDeleteUser() {
  yield takeEvery(DELETE_USER, deleteUser);
}

const getContactMethodTypesAsync = async (payload) => {
  try {

    const contactMethodTypeVocabularies = await centralApiAxios.get("/vocabularies?record_type=" + EnumRecordTypes.ContactMethodTypes + "&search_text=", getActivityHeadersUpdated(payload));

    if (
      contactMethodTypeVocabularies.data &&
      contactMethodTypeVocabularies.data.items &&
      contactMethodTypeVocabularies.data.items.length > 0
    ) {
      let vocabularyId = 0;
      const vocabularyName = "Contact Method Types";

      contactMethodTypeVocabularies.data.items.forEach((vocabulary) => {
        if (vocabulary.name === vocabularyName) {
          vocabularyId = vocabulary.vocabularyId;
        }
      });

      const contactMethodTypesReturned = await centralApiAxios.get(
        `/terms?pageSize=-1&vocabulary_id=${vocabularyId}`, getActivityHeadersUpdated(payload)
      );

      if (contactMethodTypesReturned.data.items) {
        return {
          contactMethodTypes: contactMethodTypesReturned.data.items,
          message: null,
        };
      }
      return { message: "Get Contact Method Types failed." };
    }
    return {
      contactMethodTypes: [],
      message: null,
    };
  } catch (error) {
    return {
      message: "Failed to get Contact Method Types. ",
    };
  }
};

function* getContactMethodTypes({ payload }) {

  try {
    const returnedData = yield call(getContactMethodTypesAsync, payload);
    if (!returnedData.message) {
      yield put(
        getContactMethodTypesSuccess({
          contactMethodTypes: returnedData.contactMethodTypes,
        })
      );
    } else {
      yield put(getContactMethodTypesError(returnedData.message));
    }
  } catch (error) {
    yield put(getContactMethodTypesError(error));
  }
}

const getNameTitleTermsAsync = async (payload) => {
  try {
    const contactMethodTypeVocabularies = await centralApiAxios.get(
      `/vocabularies?search_text=${payload.vocabularyName}`
      , getActivityHeadersUpdated(payload)
    );
    if (
      contactMethodTypeVocabularies.data &&
      contactMethodTypeVocabularies.data.length > 0
    ) {
      let vocabularyId = 0;

      contactMethodTypeVocabularies.data.forEach((vocabulary) => {
        if (vocabulary.name === payload.vocabularyName) {
          vocabularyId = vocabulary.vocabularyId;
        }
      });

      const contactMethodTypesReturned = await centralApiAxios.get(
        `/terms?vocabulary_id=${vocabularyId}`
      );
      if (contactMethodTypesReturned.data) {
        return {
          contactTerms: contactMethodTypesReturned.data,
          message: null,
        };
      }
      return { message: "Get Contact Method Types failed." };
    }
    return {
      contactTerms: [],
      message: null,
    };
  } catch (error) {
    return {
      message: "Failed to get Contact Method Types. ",
    };
  }
};

function* getNameTitleTerms({ payload }) {
  try {
    const returnedData = yield call(getNameTitleTermsAsync, payload);
    if (!returnedData.message) {
      yield put(
        getNameTitleTermsSuccess({ contactTerms: returnedData.contactTerms })
      );
    } else {
      yield put(getNameTitleTermsError(returnedData.message));
    }
  } catch (error) {
    yield put(getNameTitleTermsError(error));
  }
}

const getNameSuffixTermsAsync = async (payload) => {
  try {
    const contactMethodTypeVocabularies = await centralApiAxios.get(
      `/vocabularies?search_text=${payload.vocabularyName}`,
      getActivityHeadersUpdated(payload)
    );
    if (
      contactMethodTypeVocabularies.data &&
      contactMethodTypeVocabularies.data.length > 0
    ) {
      let vocabularyId = 0;

      contactMethodTypeVocabularies.data.forEach((vocabulary) => {
        if (vocabulary.name === payload.vocabularyName) {
          vocabularyId = vocabulary.vocabularyId;
        }
      });

      const contactMethodTypesReturned = await centralApiAxios.get(
        `/terms?vocabulary_id=${vocabularyId}`
        , getActivityHeadersUpdated(payload)
      );
      if (contactMethodTypesReturned.data) {
        return {
          contactTermsSuffix: contactMethodTypesReturned.data,
          message: null,
        };
      }
      return { message: "Get Contact Method Types failed." };
    }
    return {
      contactTermsSuffix: [],
      message: null,
    };
  } catch (error) {
    return {
      message: "Failed to get Contact Method Types. ",
    };
  }
};

function* getNameSuffixTerms({ payload }) {
  try {
    const returnedData = yield call(getNameSuffixTermsAsync, payload);
    if (!returnedData.message) {
      yield put(
        getNameSuffixTermsSuccess({
          contactTermsSuffix: returnedData.contactTermsSuffix,
        })
      );
    } else {
      yield put(getNameSuffixTermsError(returnedData.message));
    }
  } catch (error) {
    yield put(getNameSuffixTermsError(error));
  }
}

const updateUserAsync = async (payload) => {
  try {
    const response = await centralApiAxios.put(
      "/users?id=" + payload.user.contactId,
      payload.user,
      getActivityHeadersUpdated(payload)
    );
    if (response.data) {
      return {
        successMessage: response.data,
        message: null,
      };
    }
    return {
      message: "Failed to update User Account.",
    };
  } catch (error) {
    return {
      message: "Failed to update User Account.",
    };
  }
};

function* updateUser({ payload }) {
  try {
    const returnedData = yield call(updateUserAsync, payload);
    if (!returnedData.message) {
      yield put(updateUserSuccess(returnedData.successMessage));
    } else {
      yield put(updateUserError(returnedData.message));
    }
  } catch (error) {
    yield put(updateUserError(error));
  }
}

const createUserAccountAsync = async (payload) => {
  try {
    const response = await centralApiAxios.post("/users", payload.user, getActivityHeadersUpdated(payload));
    if (response.data) {
      return {
        successMessage: response.data,
        message: null,
      };
    }
    return {
      message: "Failed to create User Account.",
    };
  } catch (error) {
    return {
      message:
        error.response && error.response.data
          ? error.response.data
          : "Failed to create User Account. ",
    };
  }
};

function* createUserAccount({ payload }) {
  try {
    const returnedData = yield call(createUserAccountAsync, payload);
    if (!returnedData.message) {
      yield put(
        createUserAccountSuccess(
          returnedData.successMessage,
          payload.user.email,
          payload.user.userAccountType ? parseInt(payload.user.userAccountType) : null
        )
      );
    } else {
      yield put(createUserAccountError(returnedData.message));
    }
  } catch (error) {
    yield put(createUserAccountError(error));
  }
}

const changeUserPasswordAsync = async (payload) => {
  try {
    const response = await centralApiAxios.patch(
      "/users/password?reset_token=&workflowInstanceId=",
      payload.user,
      getActivityHeadersUpdated(payload)
    );
    if (response.data) {
      return {
        successMessage: response.data,
        message: null,
      };
    }
    return {
      message: "Failed to change user password.",
    };
  } catch (error) {
    return {
      message: "Failed to change user password. ",
    };
  }
};

function* changeUserPassword({ payload }) {
  try {
    const returnedData = yield call(changeUserPasswordAsync, payload);
    if (!returnedData.message) {
      yield put(
        changeUserPasswordSuccess({
          successMessage: returnedData.successMessage,
        })
      );
    } else {
      yield put(changeUserPasswordError(returnedData.message));
    }
  } catch (error) {
    yield put(changeUserPasswordError(error));
  }
}

const createContactInformationAsync = async (payload) => {
  try {
    const contactMethodsReturned = await centralApiAxios.post(
      "/contact_methods",
      {
        contactid: payload.contactId,
        contactMethods: payload.addEditContactInfo,
      },
      getActivityHeadersUpdated(payload)
    );
    if (contactMethodsReturned.data) {
      return {
        contactMethods: contactMethodsReturned.data.contact_methods,
        message: null,
      };
    }
    return {
      message: "Failed to create Contact Methods.",
    };
  } catch (error) {
    return {
      message: "Failed to create Contact Methods. ",
    };
  }
};

function* createContactInformation({ payload }) {
  try {
    const returnedData = yield call(createContactInformationAsync, payload);

    if (payload.isPageRefresh) {
      window.location.reload();
    }

    if (!returnedData.message) {
      yield put(
        createContactInformationSuccess({
          contactMethods: returnedData.contactMethods,
          primaryContactMethods: getContactPrimaryMethods(
            returnedData.contactMethods
          ),
        })
      );
    } else {
      yield put(createContactInformationError(returnedData.message));
    }
  } catch (error) {
    yield put(createContactInformationError(error));
  }
}

const getContactUserNameAsync = async (payload) => {
  try {
    const response = await centralApiAxios.get(
      `/users?user_name=${payload.userName}`
      , getActivityHeadersUpdated(payload)
    );
    return {
      isValidUserName: response.data.user_exists,
      createAllowed: response.data.create_allowed,
      message: null,
    };
  } catch (error) {
    return {
      message: "Failed to change user password. ",
    };
  }
};

const getContactAsync = async (payload) => {
  try {
    if (payload.contactId == 0) {
      return { message: "Get user info failed." };
    }

    if (payload.verbType == undefined) {
      payload.verbType = 2;
    }

    const contactReturned = await centralApiAxios.get(`/Contacts/${payload.contactId}?verbType=${payload.verbType}`, getActivityHeadersUpdated(payload));

    if (contactReturned.data) {
      return {
        contact: contactReturned.data,
        contactTypes: [],
        contactActivities: [],
        message: null,
      };
    }
    return { message: "Get user info failed." };
  } catch (error) {
    return {
      message: "Failed to get contact. ",
    };
  }
};

const updateContactAsync = async (payload) => {
  try {
    const contactReturned = await centralApiAxios.put("/Contacts?id=" + payload.contact.contactId, payload.contact, getActivityHeadersUpdated(payload));
    if (contactReturned.data) {
      return {
        contact: contactReturned.data,
        message: null,
      };
    }
    return { message: "Get user info failed." };
  } catch (error) {
    return {
      message: "Failed to get contact. ",
    };
  }
};

function* getContact({ payload }) {
  try {
    const returnedData = yield call(getContactAsync, payload);
    if (!returnedData.message) {
      yield put(
        getContactSuccess({
          contact: returnedData.contact,
          contactTypes: returnedData.contactTypes,
          contactActivities: returnedData.contactActivities,
        })
      );
    } else {
      yield put(getContactError(returnedData.message));
    }
  } catch (error) {
    yield put(getContactError(error));
  }
}

function* updateContact({ payload }) {
  try {
    const returnedData = yield call(updateContactAsync, payload);
    if (!returnedData.message) {
      yield put(
        updateContactSuccess({
          contact: returnedData.contact,
        })
      );
    } else {
      yield put(updateContactError(returnedData.message));
    }
  } catch (error) {
    yield put(updateContactError(error));
  }
}

function* getContactUserName({ payload }) {
  try {
    const returnedData = yield call(getContactUserNameAsync, payload);

    if (!returnedData.message) {
      yield put(
        getContactUserNameSuccess({
          isValidUserName: returnedData.isValidUserName,
          createAllowed: returnedData.createAllowed,
        })
      );
    } else {
      yield put(getContactUserNameError(returnedData.message));
    }
  } catch (error) {
    yield put(getContactUserNameError(error));
  }
}

const getPrimaryContactMethodsAsync = async (payload) => {

  try {
    const contactRelationsReturned = await centralApiAxios.get(
      `/contact_methods/${payload.contactId}/relations`,
      getActivityHeadersUpdated(payload)
    );
    if (contactRelationsReturned.data) {
      return {
        contactMethods: contactRelationsReturned.data.contactMethods,
        primaryContactMethods: getContactPrimaryMethods(
          contactRelationsReturned.data.contactMethods
        ),
        message: null,
      };
    }
    return { message: "Get contact primary address failed." };
  } catch (error) {
    return {
      message: "Get contact primary address failed. ",
    };
  }
};

function* getPrimaryContactMethods({ payload }) {
  try {
    const returnedData = yield call(getPrimaryContactMethodsAsync, payload);
    if (!returnedData.message) {
      yield put(
        getPrimaryContactMethodsSuccess({
          primaryContactMethods: returnedData.primaryContactMethods,
        })
      );
    } else {
      yield put(getPrimaryContactMethodsError(returnedData.message));
    }
  } catch (error) {
    yield put(getPrimaryContactMethodsError(error));
  }
}

const getContactPrimaryMethods = (allContactMethods) => {
  const primaryContactMethods = {};
  if (allContactMethods != undefined) {
    allContactMethods = allContactMethods.filter((cm) => !cm.trashed);
    for (const contactMethod of allContactMethods) {
      if (contactMethod.primary) {
        switch (parseInt(contactMethod.recordType)) {
          case EnumRecordTypes.Address:
            primaryContactMethods.Address = contactMethod;
            break;
          case EnumRecordTypes.EmailAddress:
            primaryContactMethods.EmailAddress = contactMethod;
            break;
          case EnumRecordTypes.PhoneNumber:
            primaryContactMethods.PhoneNumber = contactMethod;
            break;
          case EnumRecordTypes.FaxNumber:
            primaryContactMethods.FaxNumber = contactMethod;
            break;
          case EnumRecordTypes.Website:
            primaryContactMethods.Website = contactMethod;
            break;
          default:
            break;
        }
      }
    }
  }

  return primaryContactMethods;
};

const getContactInformationAsync = async (payload) => {
  try {
    const contactRelationsReturned = await centralApiAxios.get(`/contact_methods/${payload.contactId}/relations`, getActivityHeadersUpdated(payload));

    if (contactRelationsReturned.data) {
      return {
        contactId: payload.contactId,
        contactMethods: contactRelationsReturned.data.contactMethods,
        primaryContactMethods: getContactPrimaryMethods(
          contactRelationsReturned.data.contactMethods.filter(
            (cm) => !cm.trashed
          )
        ),
      };
    }
    return {
      message: "Failed to get contact information.",
    };
  } catch (error) {
    return {
      message: "Failed to get contact information.",
    };
  }
};

function* getContactInformation({ payload }) {
  try {
    const returnedData = yield call(getContactInformationAsync, payload);
    if (!returnedData.message) {
      yield put(getContactInformationSuccess({ ...returnedData }));
    } else {
      yield put(getContactInformationError(returnedData.message));
    }
  } catch (error) {
    yield put(getContactInformationError("Failed to get contact information."));
  }
}

const deleteUserAsync = async (payload) => {
  try {
    const dataReturned = await centralApiAxios.delete(
      `/users?userName=${payload.userName}`
      , getActivityHeadersUpdated(payload)
    );
    if (dataReturned.data) {
      return {
        successMessage: "Delete user was successful.",
        message: null,
      };
    }
    return {
      message: "Failed to delete the user.",
    };
  } catch (error) {
    return {
      message: "Failed to delete the user.",
    };
  }
};

function* deleteUser({ payload }) {
  try {
    const returnedData = yield call(deleteUserAsync, payload);
    if (!returnedData.message) {
      yield put(deleteUserSuccess(returnedData.successMessage));
    } else {
      yield put(deleteUserError(returnedData.message));
    }
  } catch (error) {
    yield put(deleteUserError("Failed to delete user."));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchGetContact),
    fork(watchGetContactUserName),
    fork(watchGetContactInformation),
    fork(watchGetContactPrimaryAddress),
    fork(watchGetContactMethodTypes),
    fork(watchGetNameTitleTerms),
    fork(watchGetNameSuffixTerms),
    fork(watchCreateContactInformation),
    fork(watchCreateUserAccount),
    fork(watchChangeUserPassword),
    fork(watchUpdateUser),
    fork(watchDeleteUser),
    fork(watchUpdateContact)
  ]);
}
